'use strict';

const body = document.querySelector('body');
const ctaBar = document.querySelector('.cta-bar');
let ctaBarHeight;
const hideCtaBar = sessionStorage.getItem('hide_cta_bar');
const closeCtaBarButton = document.querySelector('.cta-bar .cta-bar__close');
class CtaBar {

    // function to get the CTA bar height
    setCtaBarHeight() {
        ctaBarHeight = ctaBar.offsetHeight;
    }

    // function to show/hide the CTA bar
    toggleCtaBar(toggle) {
        if (ctaBar) {
            if (toggle == 'show') {
                ctaBar.style.maxHeight = `${ctaBarHeight}px`;
            } else if (toggle == 'hide') {
                ctaBar.style.maxHeight = '0px';
            }
        }
    }

    constructor() {

        if (ctaBar) {

            const self = this;

            // if theres no session storage
            if (!hideCtaBar) {
                ctaBar.classList.add('cta-bar--active');
            }

            // remove CTA bar
            closeCtaBarButton.addEventListener('click', () => {
                sessionStorage.setItem('hide_cta_bar', 'true');
                ctaBar.remove();
            })

            // listen for class changes on body element
            const observerOptions = {
                attributes: true
            }

            function callback(mutationList, observer) {
                mutationList.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (body.classList.contains('menu-open')) {
                            self.toggleCtaBar('hide');
                        } else {
                            self.toggleCtaBar('show');
                        }
                    }
                })
            }

            const observer = new MutationObserver(callback)
            observer.observe(body, observerOptions);

            // set ctaBarHeight
            this.setCtaBarHeight();

            window.addEventListener('resize', () => {
                this.setCtaBarHeight();
            })

        }

    }

}

module.exports = CtaBar;